export default __webpack_public_path__ + "static/media/youtube.fea1433f.svg";